import { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import Grid from '@mui/material/Grid';
import FormSelect from '../Form/FormSelect';

const SelectSystem = props => {
    const sysconfig = useSelector(state => state.sysconfig);

    const [value, setValue] = useState(props.value);
    const options = sysconfig?.data.map(system => ({
        value: system.SystemKey,
        system: system.SystemKey,
        label: system.Name
    }))
    useEffect(()=>{
        setValue(props.value)
    }, [props])
    return (
        <Grid container>
            <Grid item xs={12}>
                <FormSelect
                    name={props.name || "system"}
                    label="System"
                    options={options}
                    value={value || ''}
                    handler={props.handler}
                />
            </Grid>
        </Grid>
    )
}

export default SelectSystem;